import request from '@/utils/request'

let DiauthApi = {

  /*司机身份认证列表*/
  list(data) {
    return request._post('/shop/plus.diauth.Index/index', data);
},
/*添加司机身份认证*/
add(data) {
    return request._post('/shop/plus.diauth.Index/add', data);
},
/*修改司机身份认证*/
edit(data) {
    return request._post('/shop/plus.diauth.Index/edit', data);
},
/*删除司机身份认证*/
del(data) {
    return request._post('/shop/plus.diauth.Index/del', data);
},
/*司机身份认证详情*/
detail(data) {
  return request._post('/shop/plus.diauth.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.diauth.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.diauth.Setting/getSetting', data, errorback);
    },
    audit(data) {
        return request._post('/shop/plus.diauth.Index/audit', data);
    },
}
export default DiauthApi;



// WEBPACK FOOTER //
// ./src/api/diauth.js